<template>
  <div>
    <div class="d-flex">
      <CSelect
        :options="[
          { label: $t('general.components.TypeDemiliterCSV.select.semi-colon'), value: ';' },
          { label: $t('general.components.TypeDemiliterCSV.select.comma'), value: ',' },
          { label: $t('general.components.TypeDemiliterCSV.select.other'), value: 'other' },
        ]"
        :checked.sync="cvsCharacters"
        :value.sync="cvsCharacters"
        :update:value="delimiterValue()"
        :disabled="disabled"
        class="mb-0"
      >
      </CSelect>

      <CInput
        ref="inputOtherCharacters"
        v-show="cvsCharacters === 'other'"
        v-model="otherCharacters"
        @keypress="onlySpecialCharacters($event)"
        @input="delimiterValue()"
        class="ml-2 mb-0"
        :placeholder="$t('general.components.TypeDemiliterCSV.input.special-character')"
        :disabled="disabled"
        required
        maxlength="1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TypeDelimiterCSVExport',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cvsCharacters: ';',
      otherCharacters: '',
    }
  },
  methods: {
    onlySpecialCharacters: function (evt) {
      let isCharacter = new RegExp(/[!@#$%^&*(),.?":{}|<>//]/g)
      if (!evt.key.match(isCharacter)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    delimiterValue() {
      if (this.cvsCharacters === 'other') {
        this.$nextTick(() => {
          this.$refs.inputOtherCharacters.$el.childNodes[1].focus()
        })
        this.$emit('delimiterValue', this.otherCharacters)
        return
      }

      this.$emit('delimiterValue', this.cvsCharacters)
    },
  },
}
</script>
